import React, { memo, useCallback } from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import Button from '@material-ui/core/Button';
import LinkedInButton from 'Pure/LinkedInButton';
import GoogleButton from 'Pure/GoogleButton';
import MyWOIcon from 'Icons/myWO';
import bemit from 'Functions/bemit';
import { action } from 'Shared/Routes';
const {
  app
} = window;
export default memo(function BookingRegisterButtons(props) {
  const create_account = BookingFormStore.useState(s => s.create_account);
  const subscribed = BookingFormStore.useState(s => s.newsletter_subscription);
  const is__auth = BookingFormStore.useState(s => s.logged_in);
  const source = BookingFormStore.useState(s => s.source);
  const error = BookingFormStore.useState(s => s.oauth_register_error);
  const goog_loading = BookingFormStore.useState(s => s.google_register_redirecting === true);
  const lkdin_loading = BookingFormStore.useState(s => s.linkedin_register_redirecting === true);
  const signIn = useCallback(function (e, strategy) {
    BookingFormStore.update(function (store) {
      store[strategy + '_register_redirecting'] = true;
      store.oauth_strategy = strategy;
    });
    window.setTimeout(function () {
      let new_url = [document.location.origin, action('PassportAuth'), '?source=', source || 'FrontBookingPage', '&strategy=' + strategy, '&hold=true'].join('');
      if (subscribed) new_url += '&newsletter=true';
      document.location.href = new_url;
    }, 250);
  }, [subscribed, source]);
  const linkedId = useCallback(function (e) {
    signIn(e, 'linkedin');
  }, [signIn]);
  const google = useCallback(function (e) {
    signIn(e, 'google');
  }, [signIn]);
  const continueWithRegistration = useCallback(function (e) {
    e?.persist();
    app.emit({
      event: 'TC_Click',
      source: 'BookingComponent',
      data: {
        e: e,
        action: 'creation_compte'
      }
    });
    const update = {
      continue_as_guest: false,
      create_account: true,
      oauth_register_error: undefined,
      oauth_strategy: undefined,
      oauth_register: false,
      warning: undefined,
      error: undefined,
      info: undefined
    };
    BookingFormStore.update(function (store) {
      Object.keys(update).forEach(field => store[field] = update[field]);
    });
  }, []);
  if (is__auth) return;
  return /*#__PURE__*/React.createElement(React.Fragment, null, create_account !== true ? /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['myWO', 'logo']) + ' u-margin-top-0 u-margin-bottom-0',
    onClick: continueWithRegistration
  }, /*#__PURE__*/React.createElement(MyWOIcon, {
    className: "c-flat-btn__icon"
  }), "S'inscrire avec myWO") : undefined, /*#__PURE__*/React.createElement(LinkedInButton, {
    onClick: linkedId,
    text: "S'inscrire avec LinkedIn",
    className: "u-margin-top-25",
    bemit: ['blue'],
    loading: lkdin_loading
  }), /*#__PURE__*/React.createElement(GoogleButton, {
    onClick: google,
    text: "S'inscrire avec Google",
    className: "u-margin-top-25",
    loading: goog_loading
  }), error ? /*#__PURE__*/React.createElement("div", {
    className: bemit('c-message', ['v2', 'red']) + ' u-margin-top-20 u-margin-bottom-0'
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-message__content"
  }, error)) : undefined);
});
